<ng-container
  *ngIf="{
    banners: currentBanner$ | async,
    config: carouselConfig$ | async,
    showCarousel: showCarousel$ | async,
    title: title$ | async,
  } as content"
>
  <div class="container-simple-grid">
    <div class="col-12">
      <div class="container-title">
        <div class="lines">
          <p class="line-1">{{ content.title?.line1 }}</p>
          <p class="line-2">{{ content.title?.line2 }}</p>
        </div>

        <ng-container *limitUp="DEVICE_SIZE.DESKTOP">
          @if (content.title?.action?.url && content.title?.action?.label) {
            <cx-generic-link
               [url]="content.title?.action?.url!"
               [target]="content.title?.action?.isExternal ? '_blank' : '_self'"
               [ariaLabel]="content.title?.action?.label"
               [attr.title]="content.title?.action?.label"
               [class]="'action btn btn-secondary-1'"
             >
            {{ content.title?.action?.label }}
            </cx-generic-link>
          }
        </ng-container>
      </div>
    </div>

    <p-carousel
      *ngIf="content.showCarousel"
      role="region"
      [attr.aria-label]="'simple-grid'"
      [value]="content.banners || []"
      [numVisible]="4"
      [numScroll]="4"
      [showNavigators]="content.config?.showNavigators || false"
      [showIndicators]="content.config?.showIndicators || false"
      [circular]="content.config?.circular || true"
      [autoplayInterval]="content.config?.autoplayInterval || 0"
      [classList]="'custom-carousel'"
      [responsiveOptions]="responsiveOptions"
    >
      <ng-template pTemplate="item" let-item>
        <div class="custom-item container-item">
          <cx-banner [item]="item"></cx-banner>

          <div *ngIf="item.title" class="title">
            {{ item.title }}
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="previousicon" let-item>
        <span class="material-symbols-outlined text-primary"> arrow_back_ios </span>
      </ng-template>

      <ng-template pTemplate="nexticon" let-item>
        <span class="material-symbols-outlined text-primary m-l-12"> arrow_forward_ios </span>
      </ng-template>
    </p-carousel>

    <div *smallerThan="DEVICE_SIZE.DESKTOP" class="col-12">
      @if (content.title?.action?.url && content.title?.action?.label) {
        <cx-generic-link
          [url]="content.title?.action?.url!"
          [target]="content.title?.action?.isExternal ? '_blank' : '_self'"
          [ariaLabel]="content.title?.action?.label"
          [attr.title]="content.title?.action?.label"
          [class]="'action-mobile btn btn-secondary-1'"
        >
        {{ content.title?.action?.label }}
        </cx-generic-link>
      }
    </div>
  </div>
</ng-container>
